<template>
  <b-modal
    ref="self"
    class="card-form-modal"
    :active="active"
    :custom-class="'dialog mpc'"
    has-modal-card
    trap-focus
    :destroy-on-hide="true"
    aria-role="dialog"
    scroll="keep"
    aria-modal
    @close="cancel">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">What is a HELOC?</p>
        <button class="modal-close is-large active" aria-label="close" @click="cancel"></button>
      </header>
      <section class="modal-card-body">

        <div class="about">
          <div>
            <div class="about-header">
              <b>Some of the benefits of a HELOC include:</b>
            </div>
            <ol>
              <li>
                1. Potential interest savings: HELOCs generally have lower interest rates than
                home equity loans, personal loans, or credit cards. The average interest rate
                on HELOC for November 2025 is 7.64%, while the average rate for credit cards is
                22.83%.
              </li>
              <li>
                2. Potential tax savings: Interest on HELOCs might be tax-deductible if the funds
                are used to make further home improvements. The standard deduction in 2024 has
                increased to $14,600 for single filers and $29,200 for married couples filing
                jointly, giving you more benefits when borrowing for renovations.
              </li>
              <li>
                3. Flexibility: One of the main advantages of a HELOС is that it offers a
                combination of relatively low interest rates and the flexibility in terms of when
                and how much to borrow. Borrowers can draw on their credit line as needed and pay
                interest only on the amount they have borrowed. This can be useful for unexpected
                expenses or home improvement projects.
              </li>
              <li>
                4. Potential credit score improvement: The most important components of your
                credit score are your payment history and different types of credit you have.
                Adding a HELOC to your credit portfolio along with making regularly and timely
                monthly payments can improve your credit score as it demonstrates good financial
                habits.
              </li>
            </ol>
          </div>
        </div>

        <div class="about">
          <div>
            <div class="about-header">
              <b>Note this:</b>
              <p>
                The commission structure for funded HELOCs will differ from that for home
                improvement loans and will be the following:
              </p>
              <p>
                Enhancify will pay a flat $15 commission for HELOC applications with the
                qualified label* (for clients without concierge).
              </p>
              <p>
              *Qualified label is assigned by the lender after collecting information about the
              client and their further qualification. Information about this label can be found
              in the Reports tab > Applications > Received offers column. If you have any
              questions please contact your manager or
              <a href="mailto:support@enhancify.com">support@enhancify.com</a>
              </p>
            </div>
          </div>
        </div>

      </section>
    </div>
  </b-modal>
</template>

<script>

export default {
  name: 'AboutHELOC',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      email: null,
    };
  },
  methods: {
    cancel() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="stylus">
.dialog .modal-card .modal-card-body .field
  margin-top 0

.mpc
  >>> .animation-content
    max-width none !important
    width 800px

    .modal-close
      display none

      &.active
        display block
    @media (max-width: 1060px)
      width calc(100% - 10px)

  .modal-card
    max-width 100%
    max-height 75vh
    height fit-content

    &-title
      text-align center

  .modal-card-body
    padding 20px 40px
    border-radius: 0 0 6px 6px
    @media (max-width: 500px)
      padding 20px 20px

    &-subtitle
      text-align left
      margin-bottom 10px

  .modal-close
    top 50%
    transform translateY(-50%)
    border none

  .about
    margin-bottom 20px

    &-header
      margin-bottom 15px

      b
        display block

      p
        margin-top 8px

    ul, ol
      li:not(last-child)
        margin-bottom 20px

    ol
      list-style none
      margin-bottom 20px

    ul
      list-style disc
      padding-inline-start 2em

.modal-close
  background none
  right 20px
</style>
